import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import Select, { components } from "react-select";
import { useTranslate } from "../../hooks/LanguageProvider";


interface SelectGroupProps {
  id: string;
  label: string;
  icon: string;
  options: any[];
  valueType: { value: any; label: any };
  onChange?: (selectedOption: any) => void;
  handleCategoryChange?: (selectedOption: any) => void;
  placeholder?: string; // Add placeholder prop
  noOptionsMessage?: string;
  col?: string; 
  name?: string; 
}

const SelectGroupDriver: React.FC<SelectGroupProps> = ({
  id,
  label,
  icon,
  options,
  valueType,
  onChange,
  handleCategoryChange,
  placeholder, // Add placeholder to the destructuring
  noOptionsMessage,
  name
}) => {
  const { translate } = useTranslate();
  const DropdownIndicator = (props: any) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <i className={`las la-${icon}` } style={{ marginRight: '8px' ,color:"#ff7e41"}}></i>
            {props.children}
          </div>
        </components.DropdownIndicator>
      )
    );
  };

  // Custom function to render no options message
  const renderNoOptionsMessage = ({ inputValue, ...props }: { inputValue: string }) => {
    return (
      <div {...props}>
        {noOptionsMessage ? noOptionsMessage.replace("{inputValue}", inputValue) :  translate("No option for") + inputValue} 
      </div>
    );
  };

  return (
    <Form.Group  as={Row}>
    
        <Select
          options={options}
          value={valueType}
          name={name} //
          onChange={onChange || handleCategoryChange}
          components={{ DropdownIndicator }}
          className="w-100 text-start"
          id={id} // Set width to 100% 
          placeholder={placeholder} // Set placeholder
          noOptionsMessage={renderNoOptionsMessage} 
        />
     
    </Form.Group>
  );
};

export default SelectGroupDriver;
